import { Grid, Paper } from "@mui/material";
import { GoogleLogin } from "@react-oauth/google";

export default function Login(props) {
  const parseJwt = (token) => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  };
  const onSuccess = (res) => {
    const profileObj = parseJwt(res.credential);
    props.setProfile(profileObj);
  };
  const obieLogo = process.env.PUBLIC_URL + "/logo-color.svg";
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "100vh" }}
      backgroundColor="#f5f5f5"
    >
      <Paper sx={{ p: 4 }}>
        <Grid item pb={2}>
          <img alt="obie-logo" src={obieLogo} style={{ height: 56 }} />
        </Grid>
        <Grid item display="flex" justifyContent="center" pt={4}>
          <GoogleLogin
            onSuccess={onSuccess}
            onFailure={onSuccess}
            useOneTap
            auto_select
          />
        </Grid>
      </Paper>
    </Grid>
  );
}
